import { FC } from 'react';

import { ReceiptTaxIcon } from '@heroicons/react/outline';

/**
 * 결제 영수증(giftOrder.paymentDetail.receiptUrl) 새 창 링크 — 아이콘 버튼.
 * URL이 없으면(미결제·입금대기 등) 아무것도 렌더하지 않는다.
 */
export const ReceiptLinkButton: FC<{
  receiptUrl?: string | null;
  className?: string;
}> = function ReceiptLinkButton({ receiptUrl, className }) {
  if (!receiptUrl) return null;
  return (
    <a
      href={receiptUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title="영수증 보기 (새 창)"
      aria-label="영수증 보기"
      className={`inline-flex items-center rounded border border-gray-300 bg-gray-100 p-0.5 text-gray-500 hover:bg-gray-200 hover:text-gray-700 ${
        className ?? ''
      }`}
    >
      <ReceiptTaxIcon className="h-4 w-4" />
    </a>
  );
};
